import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { LayoutDefaultComponent } from './default/default.component';
import { HeaderComponent } from './default/components/header/header.component';
import { FooterComponent } from './default/components/footer/footer.component';
import { LayoutFullComponent } from './layout-full/layout-full.component';
import { SidebarComponent } from './default/components/sidebar/sidebar.component';

@NgModule({
  declarations: [ LayoutDefaultComponent, HeaderComponent, FooterComponent, LayoutFullComponent, SidebarComponent ],

  imports: [
    CommonModule,
    RouterModule
  ]
})
export class LayoutsModule { }
